import { makeStyles } from '@material-ui/core/styles';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import { PRIMARY_COLOR } from 'Config';
import React, { useState } from 'react';

const useStyles = makeStyles({
    dashboardserviceicons: (props) => ({
        padding: '15px',
        borderRadius: '3px',
        width: '100%',
        '&:hover': {
            background: `${props.hoverColor} !important`,
            color: '#fff'
        }
    })
});

const CIBILScoreIcon = (props) => {
    const propsInline = { hoverColor: PRIMARY_COLOR() };

    const classesInline = useStyles(propsInline);
    const classes = commonStyle();

    const [colorNonSelected, setColorNonSelected] = useState(
        classes.svg_non_selected
    );
    const [colorSelected, setColorSelected] = useState(classes.svg_selected);

    function MouseOver(event) {
        setColorSelected(classes.svg_white);
        setColorNonSelected(classes.svg_white);
    }
    function MouseOut(event) {
        setColorSelected(classes.svg_selected);
        setColorNonSelected(classes.svg_non_selected);
    }

    return (
        <>
            <div
                className={classesInline.dashboardserviceicons}
                onMouseOver={MouseOver}
                onMouseOut={MouseOut}
            >
                <p>
                    <svg
                        version="1.1"
                        id="Layer_1"
                        xmlns="http://www.w3.org/2000/svg"
                        x="0px"
                        y="0px"
                        viewBox="0 0 512 512"
                        style={{
                            enableBackground: 'new 0 0 512 512',
                            width: '36px'
                        }}
                    >
                        <path
                            className={colorNonSelected}
                            d="M420.4,478.8c-17.7,0.1-26.8-21.9-14-34.3c138.4-132.6,41-372-150.8-370.7C63.9,72.5-33.6,311.8,104.9,444.4
                              c18.3,19.1-8.3,46.5-27.9,28.6c-101.5-95.9-102.8-267.2-2.4-364.4C278.1-87,597.2,129.5,490.9,390.9c-13.3,
                              30.9-32.3,58.5-56.6,82.1 C430.4,476.9,425.4,478.8,420.4,478.8L420.4,478.8z" />
                        <path
                            className={colorNonSelected}
                            d="M230.6,138.7c0,13.8,11.2,25,25,25c33.1-1.2,33.1-48.8,0-50C241.8,113.7,230.6,124.9,230.6,138.7z"
                        />
                        <g>
                            <path
                                className={colorSelected}
                                d="M78.6,289.7c0,13.8,11.2,25,25,25c33.1-1.2,33.1-48.8,0-50C89.8,264.7,78.6,275.9,78.6,289.7z"
                            />
                            <path
                                className={colorSelected}
                                d="M381.7,289.7c0,13.8,11.2,25,25,25c33.1-1.2,33.1-48.8,0-50C392.8,264.7,381.7,275.9,381.7,289.7z"
                            />
                        </g>
                        <path
                            className={colorNonSelected}
                            d="M122.6,183.7c0,13.8,11.2,25,25,25c33.1-1.2,33.1-48.8,0-50C133.8,158.7,122.6,169.9,122.6,183.7z"
                        />
                        <path
                            className={colorNonSelected}
                            d="M122.6,395.8c0,13.8,11.2,25,25,25c33.1-1.2,33.1-48.8,0-50C133.8,370.8,122.6,381.9,122.6,395.8z"
                        />
                        <path
                            className={colorNonSelected}
                            d="M336.6,395.8c0,13.8,11.2,25,25,25c33.1-1.2,33.1-48.8,0-50C347.8,370.8,336.6,381.9,336.6,395.8z"
                        />
                        <path
                            d="M380.7,163.5c-7.8-7.8-20.5-7.7-28.3,0.1l-95.3,96.1c-40.8-0.4-42.3,58.3-1.5,60c17.2,0.1,31-14.6,29.9-31.8 
                         l95.3-96.1C388.6,184,388.6,171.3,380.7,163.5L380.7,163.5z" />
                    </svg>
                </p>
                <h6>CIBIL Score</h6>
            </div>
        </>
    );
};

export default CIBILScoreIcon;
